// extracted by mini-css-extract-plugin
module.exports = {"buttonLabel":"ButtonWithLabel_buttonLabel__IQsQ1","showLabel":"ButtonWithLabel_showLabel__UdXlR"};